import pushClevertapEvent from 'clevertap/pushClevertapEvent';

import formatDate from 'clevertap/formatDate';

export function reportsHourlyItemStart({
  outletsId,
  startDate,
  endDate,
  params,
}) {
  pushClevertapEvent(`Hourly Item ${params} Start`, {
    'Current Selected Outlet': outletsId,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}
export function reportsHourlyItemChangeFilter({
  outletIds,
  startDate,
  endDate,
  params,
}) {
  pushClevertapEvent(`Report Hourly Item ${params} Change Filter`, {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}
export function reportsHourlyItemExport({
  outletIds,
  startDate,
  endDate,
  params,
}) {
  pushClevertapEvent(`Report Hourly Item ${params} Export`, {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}
export function reportsHourlyItemFTUE(type) {
  pushClevertapEvent(`Report Hourly Item ${type} FTUE`);
}
